import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import {
  Avatar,
  Badge,
  Box,
  Button,
  Divider,
  MenuItem,
  MenuList,
  Paper,
  Popover,
  Stack,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router';

import { BASE } from 'common/src/routes/BaseRoutes';

import useAuth from 'portal/src/auth/useAuth';
import { useAlertsBadgeCount } from 'portal/src/hooks/useAlertsBadgeCount';
import { useHasAlertsFeature } from 'portal/src/hooks/useHasAlertsFeature';
import { getNameInitials } from 'portal/src/utils/names';

/** @deprecated Temporary dual-layout rollout legacy user profile popup. Remove when legacy layout is retired. */
const UserProfilePopupLegacy = () => {
  const navigate = useNavigate();
  const { getUser, getUserPicture, logout } = useAuth();
  const { name, email } = getUser();
  const hasAlertsFeature = useHasAlertsFeature();
  const { count, isError } = useAlertsBadgeCount();

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  return (
    <>
      <Button
        onClick={(event) => setAnchorEl(anchorEl ? null : event.currentTarget)}
        sx={{
          textTransform: 'none',
          color: 'text.primary',
        }}
      >
        <Badge
          badgeContent={count}
          color="error"
          overlap="circular"
          invisible={!hasAlertsFeature || isError}
          sx={{ mr: 1 }}
        >
          <Avatar src={getUserPicture()}>{getNameInitials(name)}</Avatar>
        </Badge>
        <KeyboardArrowDownIcon />
      </Button>
      <Popover
        open={!!anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Paper>
          <Box sx={{ px: 2, py: 1 }}>
            <Stack display="flex">
              <Typography variant="h6">{name}</Typography>
              <Typography variant="body2" color="textSecondary">
                {email}
              </Typography>
            </Stack>
          </Box>
          <Divider />
          <MenuList sx={{ pt: 0 }}>
            {hasAlertsFeature && (
              <MenuItem
                tabIndex={0}
                onClick={() => {
                  navigate(BASE.ALERTS);
                  setAnchorEl(null);
                }}
              >
                Alerts
              </MenuItem>
            )}
            <MenuItem
              tabIndex={0}
              onClick={() => {
                navigate(BASE.USER_SETTINGS);
                setAnchorEl(null);
              }}
            >
              Profile & Preferences
            </MenuItem>
            <MenuItem
              tabIndex={0}
              sx={{ borderTop: '1px solid', borderColor: 'divider' }}
              onClick={() => {
                logout();
                navigate('/');
              }}
            >
              Logout
            </MenuItem>
          </MenuList>
        </Paper>
      </Popover>
    </>
  );
};

export default UserProfilePopupLegacy;
